import { ReactNode } from 'react';

import { useClipboard } from '@chakra-ui/react';

import { HStack, Text } from 'components/uikit';
import { DynamicCopyIcon } from 'components/uikit/CopyWrapper';

interface CardRowProps {
  label: ReactNode;
  value: string;
  displayedValue?: ReactNode;
  copy?: boolean;
}

export function CardRow({
  label,
  value,
  displayedValue = value,
  copy = false,
}: CardRowProps) {
  const { onCopy, hasCopied } = useClipboard(value);

  return (
    <HStack
      py='8px'
      px='16px'
      cursor={copy ? 'pointer' : undefined}
      justify='space-between'
      flexDir='row'
      onClick={copy ? onCopy : undefined}
    >
      <Text
        as='h3'
        fontSize='sm'
        fontWeight='medium'
        color='grey.secondaryText'
        textAlign={['start']}
      >
        {label}
      </Text>
      <Text
        as='h3'
        fontSize='xl'
        textAlign={['end']}
        fontWeight='medium'
        variant='numeric'
      >
        {displayedValue}
        {copy ? (
          <DynamicCopyIcon hasCopied={hasCopied} ml='8px' boxSize='18px' />
        ) : null}
      </Text>
    </HStack>
  );
}
